module.exports = __webpack_public_path__ + "static/img/hwaq_banner.306fae8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hwaq_banner.jpg
// module id = Zi0a
// module chunks = 21